// Generated by tools/animation/extract_shenmue2_uv_animations.py.
// Native deltas are per Shenmue II game update (30 updates/second).
export const SHENMUE_II_NATIVE_UV_ANIMATIONS = Object.freeze(
  [
    {
      "sceneGroup": "01",
      "roomId": "AR02",
      "ev1File": "AR02.EV1",
      "instructionOffset": 2046,
      "modelIndex": 16,
      "sourceUPerUpdate": 0.00015,
      "sourceVPerUpdate": 0.0001
    },
    {
      "sceneGroup": "01",
      "roomId": "AR02",
      "ev1File": "AR02.EV1",
      "instructionOffset": 2192,
      "modelIndex": 17,
      "sourceUPerUpdate": 0.0,
      "sourceVPerUpdate": 0.055
    },
    {
      "sceneGroup": "01",
      "roomId": "AR02",
      "ev1File": "AR02.EV1",
      "instructionOffset": 2216,
      "modelIndex": 18,
      "sourceUPerUpdate": 0.0,
      "sourceVPerUpdate": 0.027
    },
    {
      "sceneGroup": "04",
      "roomId": "KRK2",
      "ev1File": "KRK2.EV1",
      "instructionOffset": 480,
      "modelIndex": 3,
      "sourceUPerUpdate": 0.0,
      "sourceVPerUpdate": -0.04
    },
    {
      "sceneGroup": "04",
      "roomId": "KRK4",
      "ev1File": "KRK4.EV1",
      "instructionOffset": 272,
      "modelIndex": 2,
      "sourceUPerUpdate": 0.0,
      "sourceVPerUpdate": 0.005
    },
    {
      "sceneGroup": "04",
      "roomId": "KRK4",
      "ev1File": "KRK4.EV1",
      "instructionOffset": 296,
      "modelIndex": 3,
      "sourceUPerUpdate": 0.0,
      "sourceVPerUpdate": -0.004
    },
    {
      "sceneGroup": "04",
      "roomId": "KRK4",
      "ev1File": "KRK4.EV1",
      "instructionOffset": 318,
      "modelIndex": 4,
      "sourceUPerUpdate": 0.0,
      "sourceVPerUpdate": 0.02
    }
  ]
    .map((entry) => Object.freeze(entry)),
);
